<template lang="html">
  <section class="text-legal pad-sec" v-html="$t('politica_privacidad')">
  </section>
</template>

<script lang="js">
export default {
  name: 'politica-privacidad'
}
</script>


// WEBPACK FOOTER //
// src/components/views/politica-privacidad.vue